import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

export default class DateTimePicker extends React.PureComponent {
  render() {
    const {
      className,
      dateFormat,
      disabled,
      maxDate,
      minDate,
      name,
      onChange,
      readOnly,
      showTime,
      timeIntervals,
      value,
      ...passProps
    } = this.props;
    return (
      <ReactDatePicker
        className={className}
        dateFormat={
          dateFormat || (showTime ? "MM/DD/YYYY h:mm a" : "MM/DD/YYYY")
        }
        disabled={disabled}
        id={name}
        maxDate={maxDate ? moment(maxDate) : undefined}
        minDate={minDate ? moment(minDate) : undefined}
        onChange={(date) => onChange(name, date?.toDate())}
        readOnly={readOnly}
        selected={value ? moment(value) : null}
        showTimeSelect={showTime}
        timeIntervals={showTime ? timeIntervals || 15 : undefined}
        {...passProps}
      />
    );
  }
}
